const initialState = {
  loading: false,
  data: null,
  error: null,
};

export const WorldPayReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SEND_WORLDPAY_PAYMENT_REQUEST':
      return { ...state, loading: true, error: null };
    case 'SEND_WORLDPAY_PAYMENT_SUCCESS':
      return { ...state, loading: false, data: action.payload };
    case 'SEND_WORLDPAY_PAYMENT_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};